export const iphone = {
  id: 'iphone',
  label: 'iPhone',
  emoji: '📱',
  colorScheme: 'blue',
  description: 'iPhone home screen, spotlight, notifications & App Store',
  folder: 'ios/AppIcon.appiconset',
  icons: [
    { filename: 'Icon-20@1x.png',  size: 20,   pointSize: 20,   scale: 1, idiom: 'iphone', label: 'Notification @1x' },
    { filename: 'Icon-20@2x.png',  size: 40,   pointSize: 20,   scale: 2, idiom: 'iphone', label: 'Notification @2x' },
    { filename: 'Icon-20@3x.png',  size: 60,   pointSize: 20,   scale: 3, idiom: 'iphone', label: 'Notification @3x' },
    { filename: 'Icon-29@1x.png',  size: 29,   pointSize: 29,   scale: 1, idiom: 'iphone', label: 'Settings @1x' },
    { filename: 'Icon-29@2x.png',  size: 58,   pointSize: 29,   scale: 2, idiom: 'iphone', label: 'Settings @2x' },
    { filename: 'Icon-29@3x.png',  size: 87,   pointSize: 29,   scale: 3, idiom: 'iphone', label: 'Settings @3x' },
    { filename: 'Icon-40@2x.png',  size: 80,   pointSize: 40,   scale: 2, idiom: 'iphone', label: 'Spotlight @2x' },
    { filename: 'Icon-40@3x.png',  size: 120,  pointSize: 40,   scale: 3, idiom: 'iphone', label: 'Spotlight @3x' },
    { filename: 'Icon-60@2x.png',  size: 120,  pointSize: 60,   scale: 2, idiom: 'iphone', label: 'Home Screen @2x' },
    { filename: 'Icon-60@3x.png',  size: 180,  pointSize: 60,   scale: 3, idiom: 'iphone', label: 'Home Screen @3x' },
    { filename: 'Icon-1024.png',   size: 1024, pointSize: 1024, scale: 1, idiom: 'ios-marketing', label: 'App Store' },
  ],
};
